// extracted by mini-css-extract-plugin
export default {"InfoBox":"InfoBox_InfoBox__LtsRR","InfoIcon":"InfoBox_InfoIcon__UfyuV","Context":"InfoBox_Context__aZkGw"};